import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=d35f0dae&"
import script from "./facility.vue?vue&type=script&lang=ts&"
export * from "./facility.vue?vue&type=script&lang=ts&"
import style0 from "./facility.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports